import { withEventBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/eventBased';

import type { SportsHomePageState } from './types';

export const defaultState = withEventBasedMarketTemplateModelState<SportsHomePageState>({
  isLoading: false,
  hasPreloaded: false,
  popularBetBuilders: []
});
